















// vue
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
    name: 'PageHeader'
})
export default class PageHeader extends Vue {
    @Prop({ required: true, type: String }) title!: string
    @Prop({ required: true, type: Array }) items!: []
}
